import React from "react";

const Loader = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/60 dark:bg-black/60">
      <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-custom-500 border-solid"></div>
    </div>
  );
};

export default Loader;
